module.exports = __webpack_public_path__ + "img/rejected.2062c723.svg";